import React from 'react';
import { CreateCuttingConfigModal } from './CreateCuttingConfigModal';

interface CuttingConfigModalsProps {
  onCreateSuccess?: () => void;
}

const CuttingConfigModals: React.FC<CuttingConfigModalsProps> = ({
  onCreateSuccess,
}) => {
  return (
    <>
      <CreateCuttingConfigModal onSuccess={onCreateSuccess} />
    </>
  );
};

export default CuttingConfigModals;
